const e=e=>Object.assign(e,{single:!0});export{e as toSingle};
//# sourceMappingURL=toSingle-Bfpp5_i-.js.map